<template>
  <scatter
    :chart-data="data"
    :chart-options="options"
    :plugins="plugins"
  />
</template>

<script>
import Chart from 'chart.js/auto';
import {Scatter} from "vue-chartjs/legacy";

export default {
  name: 'BarChart',
  components: {
    Scatter
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 200
    }
  }
}
</script>